import moment from 'moment';
import { WORKING_HOURS_ORDER_TYPE } from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/types/branchEdit';
import { TBranchWorkingTime } from '~/view/screens/BranchesManagementScreen/screens/BranchesWorkingHours/types';

export interface IWorkingHoursValidation {
  isValidStartTime: boolean;
  isValidCloseTime: boolean;
  isValidFullDay: boolean;
  isValidOrderType: boolean;
}

export const validateWorkingHours = (
  id: number | undefined,
  currDay: string,
  startTime: moment.Moment,
  closeTime: moment.Moment,
  isFullDay: boolean,
  orderTypes: WORKING_HOURS_ORDER_TYPE[],
  timeSlots: TBranchWorkingTime[]
): IWorkingHoursValidation => {
  const validation = {
    isValidStartTime: true,
    isValidCloseTime: true,
    isValidFullDay: true,
    isValidOrderType: true,
  };

  // exclude editable timeslot from list
  const remainingSlots = timeSlots.filter((slot) => slot.id !== id);

  // order types validation
  if (!orderTypes.length) {
    validation.isValidOrderType = false;
  }

  // full day validation
  if (isFullDay && remainingSlots.filter((slot) => slot.weekday === currDay).length) {
    validation.isValidFullDay = false;
    // skip other validation if full day validation failed
    return validation;
  }

  // Time validation
  [validation.isValidStartTime, validation.isValidCloseTime] = validateTime(currDay, startTime, closeTime, remainingSlots);

  return validation;
};

const validateTime = (currDay: string, startTime: moment.Moment, closeTime: moment.Moment, slots: TBranchWorkingTime[]): [boolean, boolean] => {
  const isTimeOverlapsNextDay = closeTime.isBefore(startTime);

  let isStartTimeValid = true;
  let isCloseTimeValid = true;

  if (startTime.isSame(closeTime)) {
    isCloseTimeValid = false;
  }

  slots.forEach((slot) => {
    const slotStartTime = moment(slot.startTime, 'HH:mm:ss');
    const slotCloseTime = moment(slot.closeTime, 'HH:mm:ss');

    // NOTE: set the result of validation if it`s failed and the previous value is valid, otherwise skip checking

    if (slot.weekday === currDay) {
      if (isStartTimeValid) {
        isStartTimeValid = !isTimeWithinSlotTimeframe(startTime, slotStartTime, slotCloseTime);
      }

      if (isCloseTimeValid) {
        // check if slot is inside of the validated timeframe
        const isSlotInsideTimeframe =
          slotStartTime.isBetween(startTime, closeTime, null, '[]') && slotCloseTime.isBetween(startTime, closeTime, null, '[]');

        isCloseTimeValid = !isSlotInsideTimeframe && !isTimeWithinSlotTimeframe(closeTime, slotStartTime, slotCloseTime);
      }
    } else if (isTimeOverlapsNextDay && isCloseTimeValid) {
      // check if close time is not overlapping next day slot
      isCloseTimeValid = !closeTime.isSameOrAfter(slotCloseTime) && !isTimeWithinSlotTimeframe(closeTime, slotStartTime, slotCloseTime);
    }
  });

  return [isStartTimeValid, isCloseTimeValid];
};

const isTimeWithinSlotTimeframe = (time: moment.Moment, slotStartTime: moment.Moment, slotCloseTime: moment.Moment) => {
  return time.isBetween(slotStartTime, slotCloseTime, null, '()');
};
